import { Suspense, lazy, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Top from "./components/views/pages/top/Top";
import NotFound from "./components/views/pages/notfound/NotFound";

const LINE = lazy(() => import("./components/views/pages/communication/LINE"));
const Law = lazy(() => import("./components/views/pages/important/Law"));
const PrivacyPolicy = lazy(
  () => import("./components/views/pages/important/PrivacyPolicy")
);
const Terms = lazy(() => import("./components/views/pages/important/Terms"));

const DEFAULT_TITLE = "Lamact - 困りごとも、面白いことも、一緒につくる。";
const DEFAULT_DESCRIPTION =
  "少数精鋭のチームが、業務システムから遊び心のあるWebアプリまで、あなたにちょうどいい形でつくります。";

const PAGE_META: Record<string, { title: string; description?: string }> = {
  "/": { title: DEFAULT_TITLE },
  "/line": { title: "お問い合わせ | Lamact" },
  "/law": { title: "特定商取引法に基づく表記 | Lamact" },
  "/privacyPolicy": { title: "プライバシーポリシー | Lamact" },
  "/terms": { title: "利用規約 | Lamact" },
};

function usePageMeta() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const normalized = pathname.replace(/\/+$/, "") || "/";
    const meta = PAGE_META[normalized];
    document.title = meta?.title ?? DEFAULT_TITLE;
    const description = document.querySelector('meta[name="description"]');
    if (description) {
      description.setAttribute(
        "content",
        meta?.description ?? DEFAULT_DESCRIPTION
      );
    }
    // ルートのハッシュ付きURLは該当セクションへスムーススクロール
    if (normalized === "/" && hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
}

function Router() {
  usePageMeta();
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<Top />} />
        {/* 旧ページURLはルートの各セクションへリダイレクト */}
        <Route path="/service" element={<Navigate to="/#service" replace />} />
        <Route path="/case" element={<Navigate to="/#case" replace />} />
        <Route path="/case/:slug" element={<Navigate to="/#case" replace />} />
        <Route path="/works" element={<Navigate to="/#case" replace />} />
        <Route path="/lab" element={<Navigate to="/#lab" replace />} />
        <Route path="/about" element={<Navigate to="/#about" replace />} />
        <Route path="/line" element={<LINE />} />
        <Route path="/law" element={<Law />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}

export default Router;
